import { getBaseUrlVersioned } from "../services/axiosClient";
export function createApiUrl({ path, params, }) {
    const base = `${getBaseUrlVersioned(null)}/${path}`;
    if (!params || Object.keys(params).length === 0)
        return base;
    const searchParams = new URLSearchParams(params);
    return `${base}?${searchParams.toString()}`;
}
